import { z } from 'zod'

import { afterValid } from '~/services/api/contracts/afterValid'
import { email } from '~/services/api/contracts/email'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { phone } from '~/services/api/contracts/phone'
import { UserCreateRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'
import { refinePasswordConfirmation } from '~/services/api/contracts/refinePasswordConfirmation'

const normalize = fieldNormalizer({
  trimmed: ['name', 'last_name', 'email'],
  blankToNull: ['phone'],
  enums: [{ field: 'status', options: UserCreateRequestSchema.shape.status.options }]
})

const DashboardCreateUserSchema = UserCreateRequestSchema.extend({
  email: email(255),
  // Not independently required server-side; a mismatch is reported via the
  // confirmation refinement below instead of a bare "required" error here.
  password_confirmation: z.string().min(1).optional(),
  phone: phone.nullish()
}).strict()

export const DashboardCreateUser = (_context: NoContext = {}) =>
  z.preprocess(normalize, afterValid(DashboardCreateUserSchema, refinePasswordConfirmation))
